import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit(event) {
    const input = event?.target || this.element;
    const form = input?.closest && input.closest("form");
    if (!form) return;

    // Use requestSubmit when available to trigger Rails UJS/Turbo behaviors
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }
}


